import FixturesTable from "@components/competitions/FixturesTable";
import Utils from "@utils";

const { DateUtils } = Utils;

const FixturesScore = ({ fixtures }) => {
  return (
    <>
      {fixtures.map((groupedFixtures) => (
        <FixturesTable
          key={groupedFixtures.title}
          title={DateUtils.fromTimestampToUserTimezoneFormat(
            groupedFixtures.title,
            "EEEE, dd LLL"
          )}
          fixtureKey={(fixture) => fixture.fixture.id}
          fixtures={groupedFixtures.fixtures}
        />
      ))}
    </>
  );
};

export default FixturesScore;
